










import {Vue, Component, Prop} from "vue-property-decorator";
import SingleSelect from "@share/common/form/form-controls/select/variations/single-select/SingleSelect.vue";
import {RepositoryFabric} from "@api/repositories/RepositoryFabric";
import {ObjectRepository} from "@api/repositories/ObjectRepository";
import {UserRepository} from "@api/repositories/UserRepository";
import {FilterSetting} from "@common/table/interfaces/FilterSetting";
import {FilterSettingItemData} from "@common/table/interfaces/FilterSettingItemData";
import {SelectedItem} from "@common/table/interfaces/SelectedItem";
import { Debounce } from "vue-debounce-decorator";
import { prepareProfileFilter } from "@api/helpers/profileSearch";
import { getUserInfoForSelectTitle } from "@share/common/helpers/userProfileNameHelper";

@Component({
    components: {SingleSelect}
})

export default class FilterSelect extends Vue {
    @Prop({default: {}}) filterItem: FilterSetting;
    @Prop({default: ''}) placeholder: string;
    value: object[] = [];
    objectRepository: ObjectRepository;
    userRepository: UserRepository;
    focused = false;

    setValue(value: SelectedItem) {
        this.filterItem.selectedItem = value;
        this.$emit('setSelectValue', this.filterItem);
    }

    created() {
        this.objectRepository = this.$repositories.get(RepositoryFabric.OBJECT);
        this.userRepository = this.$repositories.get(RepositoryFabric.USER);
        this.value = this.filterItem.data ? this.filterItem.data : [];
        if (this.filterItem.ref) {
            this.value = [];
        }
    }

    get selectData() {
        return this.value;
    }

    @Debounce(400)
    async selectDataSearch(keyword = '') {
        if(keyword.length < 2) {
            return []
        }

        if (this.filterItem.ref) {

            if (this.filterItem.ref === 'UserProfiles') {

                const condition = prepareProfileFilter({
                    searchStr: keyword,
                    additionalFields: ['middleName'],
                });

                let profiles = await this.userRepository.profiles({
                    where: condition,
                    order: [
                        {
                            column: 'firstName',
                            direction: 'asc'
                        }
                    ],
                    take: 100
                });

                if (profiles) {
                    this.value = profiles.map((item) => {
                        return {
                            id: item.userId,
                            title: getUserInfoForSelectTitle(item, "direction")
                        };
                    });
                    return this.value;
                }
            } else {
                let include: (string | Record<string, string[]>)[] = ['id', 'title'];

                if (this.filterItem.titleAddition) {
                    include = [...include, this.filterItem.titleAddition];
                }

                let result = await this.objectRepository.query(this.filterItem.ref, {
                    where: {
                        title: {
                            $regex: `(?i).*${keyword}.*`
                        },
                        ...this.filterItem.condition
                    },
                    order: [
                        {
                            column: 'title',
                            direction: 'asc'
                        }
                    ],
                    include,
                    take: -1
                });
                if (result) {
                    this.value = result.map((item) => {
                        let sourceValue = null;
                        if (this.filterItem.titleAddition) {
                            const refFieldName = Object.keys(this.filterItem.titleAddition)[0];
                            const sourceFieldName = this.filterItem.titleAddition[refFieldName][0];
                            sourceValue = item[refFieldName][sourceFieldName] || null;
                        }

                        return {
                            id: item.id,
                            title: sourceValue
                                ? `${item.title} (${sourceValue})`
                                : item.title
                        };
                    });
                    return this.value;
                }
            }
        }

        if (this.filterItem.data && Array.isArray(this.filterItem.data)) {
            this.value = this.filterItem.data
                .filter((item: FilterSettingItemData) => item.title.toLowerCase().indexOf(keyword.toLowerCase()) !== -1);
            return this.value;
        }

        return [];
    }

}
